module.exports = [
  {
    label: 'botdialog',
    logins: [
      '41a87957-01a1-46b4-a4ca-2eacab3cb148',
      '3cc838f4-0ac1-45f6-bea4-b1b28b049251',
      '3a5b8bb4-36d4-48de-ae7a-11c5ffdfa231',
      'a5a559b8-06da-4e8f-986a-b2421abd37b3',
    ],
  },
  {
    label: 'sa',
    logins: [
      '41a87957-01a1-46b4-a4ca-2eacab3cb148',
      '3cc838f4-0ac1-45f6-bea4-b1b28b049251',
      '3a5b8bb4-36d4-48de-ae7a-11c5ffdfa231',
      'a5a559b8-06da-4e8f-986a-b2421abd37b3',
      '98b9744a-e0da-4d92-9bf7-1bc361b9a54d',
      '99b20b4d-b784-491f-bf99-09903ba46bfe',
      '12aff633-2158-4daf-b63b-bc08feaa0aae',
      '0b264b20-dc1a-40e9-87d2-8877b5a0e089',
      'a98e69d8-9c90-48cd-ae61-de4628be2b15',
      '6fc9447c-ddc3-4b0c-9af5-464471e5cd55',
      '28f6732b-5f23-415b-9325-2779f11a9143',
      '5289ce89-41fd-4cc4-89a5-db7612bb89c4',
      '81fa45d4-aaa0-45a3-9e95-6b267b2ecc50',
      '778841f6-7c14-4264-80ed-0b3aa0b0e444',
      'f50e7b2e-e358-49c9-8dfb-10e81595b714',
    ],
  },
  {
    label: 'hotels',
    logins: [
      '41a87957-01a1-46b4-a4ca-2eacab3cb148',
      '3cc838f4-0ac1-45f6-bea4-b1b28b049251',
      'a5a559b8-06da-4e8f-986a-b2421abd37b3',
    ],
  },
  {
    label: 'doctors',
    logins: [
      '41a87957-01a1-46b4-a4ca-2eacab3cb148',
      '3cc838f4-0ac1-45f6-bea4-b1b28b049251',
      'a5a559b8-06da-4e8f-986a-b2421abd37b3',
    ],
  },
  {
    label: 'hh',
    logins: [
      '41a87957-01a1-46b4-a4ca-2eacab3cb148',
      '3cc838f4-0ac1-45f6-bea4-b1b28b049251',
      'a5a559b8-06da-4e8f-986a-b2421abd37b3',
    ],
  },
  {
    label: 'hp',
    logins: [
      '41a87957-01a1-46b4-a4ca-2eacab3cb148',
      '3cc838f4-0ac1-45f6-bea4-b1b28b049251',
      'a5a559b8-06da-4e8f-986a-b2421abd37b3',
    ],
  },
  {
    label: 'qbot',
    logins: [
      '41a87957-01a1-46b4-a4ca-2eacab3cb148',
      '3cc838f4-0ac1-45f6-bea4-b1b28b049251',
      'a5a559b8-06da-4e8f-986a-b2421abd37b3',
    ],
  },
  {
    label: 'rh',
    logins: [
      '41a87957-01a1-46b4-a4ca-2eacab3cb148',
      '3cc838f4-0ac1-45f6-bea4-b1b28b049251',
      'a5a559b8-06da-4e8f-986a-b2421abd37b3',
    ],
  },
  {
    label: 'salons',
    logins: [
      '41a87957-01a1-46b4-a4ca-2eacab3cb148',
      '3cc838f4-0ac1-45f6-bea4-b1b28b049251',
      'a5a559b8-06da-4e8f-986a-b2421abd37b3',
    ],
  },
  {
    label: 'tourism',
    logins: [
      '41a87957-01a1-46b4-a4ca-2eacab3cb148',
      '3cc838f4-0ac1-45f6-bea4-b1b28b049251',
      'a5a559b8-06da-4e8f-986a-b2421abd37b3',
    ],
  },
  {
    label: 'vvn',
    logins: [
      '41a87957-01a1-46b4-a4ca-2eacab3cb148',
      '3cc838f4-0ac1-45f6-bea4-b1b28b049251',
      '3a5b8bb4-36d4-48de-ae7a-11c5ffdfa231',
      'a5a559b8-06da-4e8f-986a-b2421abd37b3',
    ],
  },
  {
    label: 'northable',
    logins: [
      '41a87957-01a1-46b4-a4ca-2eacab3cb148',
      '3cc838f4-0ac1-45f6-bea4-b1b28b049251',
      'a5a559b8-06da-4e8f-986a-b2421abd37b3',
    ],
  },
];
